(function(){
  if (window.__agbCount) return; window.__agbCount = true;
  function run(){
    var els = document.querySelectorAll('[data-agb-count]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function animate(el){
      var raw = el.getAttribute('data-agb-count');
      var target = parseFloat(raw.replace(',', '.'));
      var dec = (raw.split(/[.,]/)[1] || '').length;
      var sep = raw.indexOf(',') > -1 ? ',' : '.';
      if (isNaN(target) || reduce) { el.textContent = raw; return; }
      var start = null, dur = 1400;
      function step(t){
        if (!start) start = t;
        var p = Math.min((t - start) / dur, 1);
        var e = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * e).toFixed(dec).replace('.', sep);
        if (p < 1) requestAnimationFrame(step); else el.textContent = raw;
      }
      requestAnimationFrame(step);
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting) { animate(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.4 });
    els.forEach(function(el){ io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
